

import { CRMService } from '../../libs/ui/src/abstractServices/apiServices/crmService';
import { client } from '../apiService';

const _CRMService = new CRMService({ client });
export { _CRMService as CRMService };